import { Injectable } from '@angular/core';
import { ExtendedComponentStore } from '@mhe/reader/common';

import { defaultUserSettings, UserSettings } from '../models';
import * as actions from './user-settings.actions';

@Injectable()
export class UserSettingsStore extends ExtendedComponentStore<
  UserSettings,
  actions.UserSettingsActions
> {
  constructor() {
    super(defaultUserSettings);
  }

  readonly translationTargetLanguage$ = this.select(state => state.translationTargetLanguage);

  /** selectors */
  readonly userSettings$ = this.select((
    { fontSize, teacherContentEnabled, translationTargetLanguage, autoPageTurn, ttsPlaybackRate, ttsVolume },
  ) => {
    return { fontSize, teacherContentEnabled, translationTargetLanguage, autoPageTurn, ttsPlaybackRate, ttsVolume };
  });

  readonly setUserSettings = this.updater((state, userSettings: UserSettings) => {
    return { ...state, ...userSettings };
  });
}
